<template>

    <SubHeader title="Liste des Affectation" :breads="[{name:'Affectation'}]" />
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header">
                    <div class="row justify-content-between align-items-center flex-grow-1">
                        <div class="col-12 col-md">
                            <div class="d-flex justify-content-between align-items-center">
                                <router-link :to="{ name: 'AdminConfigCreateAffectation' }"
                                    class="btn btn-outline-primary btn-xs">
                                    <i class="bi bi-plus me-1"></i> Ajouter
                                </router-link>
                            </div>
                        </div>

                        <div class="col-auto">
                            <!-- Filter -->
                            <form>
                                <!-- Search -->
                                <div class="input-group input-group-merge input-group-flush">
                                    <div class="input-group-prepend input-group-text">
                                        <i class="bi-search"></i>
                                    </div>
                                    <input id="datatableWithSearchInput" type="search" class="form-control"
                                        placeholder="Search affectation" v-model="searchWord" aria-label="Search affectation">
                                </div>
                                <!-- End Search -->
                            </form>
                            <!-- End Filter -->
                        </div>
                    </div>
                </div>
                <div class="card-body datatable-custom position-relative">
           
                    <data-table :rows="items" :columns="cols" :loading="isLoading"
                        :sortable="true" sortColumn="label" sortDirection="asc" paginationInfo="De {0} à {1} sur un total de {2}"
                        :search="searchWord" noDataContent="Pas de resultat"
                        class="advanced-table whitespace-nowrap table table-borderless table-thead-bordered ">
                        <template #action="{value}">
                            <div class="btn-group" role="group" aria-label="Button group with nested dropdown">
                     
                                        <!-- a href="" class="btn btn-outline-dark btn-xs" title="Voir le résumé"><i class="bi bi-eye"></i></a -->
                                        <router-link :to="{ name: 'AdminConfigShowAffectation', params: { id: value.id } }"
                                            class="btn btn-outline-dark btn-xs" title="Voir la fiche">
                                            <i class="bi bi-eye"></i>
                                        </router-link>
                                    </div>
                        </template>
                    </data-table>
                </div>
           
            </div>
        </div>
    </div>
</template>
<script>

import SubHeader from "@/layouts/admin/SubHeader.vue"
import { mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
    name: "AdminConfigAffectation",
    components:{
        SubHeader
    },
    data() {
        return {
            cols: [
                { field: 'label', title: 'Affectation' },
                { field: 'sms', title: 'SMS' },
                { field: 'message', title: 'Email' },
                { field: 'action', title: 'Actions', sort: false, width: '10px', headerClass: 'justify-center', cellClass: 'justify-center' },

            ],
            searchWord:null
        }
    },

    computed: {
        ...mapFields("affectation/list", {
            isLoading: "isLoading",
            isSuccess: "isSuccess",
            showMessage: "showMessage",
            message: "message",
            items: "items"

        })
    },

    methods: {
        ...mapActions({
            getAffectations: "affectation/list/getAll",
            reset: "affectation/list/resetData",
        })
    },
    mounted() {
        this.getAffectations()
    },
    unmounted(){
        this.reset()
    }
}
</script>
